import React from 'react'
import * as AiOutlinePlus from 'react-icons/ai'
import * as GrAccessibility from "react-icons/gr";
import './Trellosidebar.css'

const Members = () => {
  return (
    <div className='divallcontainer'>
    <div className='d-flexdiv'>
        
        <div className = 'diviconsdiv'>
            <GrAccessibility.GrAccessibility/>
            </div>
        <p className='divcolormem'>Member
         </p>
        
         
    </div>
     <div className='divextractdiv'>
         < AiOutlinePlus.AiOutlinePlus/>
         </div>
         </div>
  )
}

export default Members